import React from "react";
import {
  AvatarFrameGradientRedPng,
  AvatarFrameGradientGoldPng,
  AvatarFrameGradientBluePng,
} from "../../../assets";
import { ImageBackground } from "react-native";
import { AvatarFrame } from "../index";
import {
  AvatarGradientColor,
  AvatarLevelPosition,
  AvatarSparklePosition,
} from "../../../../typings/types";

const AvatarFrameWithGradient = ({
  gradientColor,
  levelPosition,
  sparklePosition,
  showVipBadge,
  showUsernameFrame,
  sizeMultiplier = 1,
}: {
  gradientColor: AvatarGradientColor;
  levelPosition?: AvatarLevelPosition;
  sparklePosition?: AvatarSparklePosition;
  showVipBadge?: boolean;
  showUsernameFrame?: boolean;
  sizeMultiplier?: number;
}) => {
  const gradientSource =
    gradientColor === AvatarGradientColor.Gold
      ? AvatarFrameGradientGoldPng
      : gradientColor == AvatarGradientColor.Blue
        ? AvatarFrameGradientBluePng
        : AvatarFrameGradientRedPng;

  return (
    <ImageBackground
      source={gradientSource}
      style={{
        zIndex: 2,
        width: 105 * sizeMultiplier,
        height: 105 * sizeMultiplier,
      }}
    >
      <AvatarFrame
        hasGradient={true}
        levelPosition={levelPosition}
        sparklePosition={sparklePosition}
        showVipBadge={showVipBadge}
        showUsernameFrame={showUsernameFrame}
        sizeMultiplier={sizeMultiplier}
      />
    </ImageBackground>
  );
};
export default AvatarFrameWithGradient;
